module.exports = __webpack_public_path__ + "img/donut-tab.15bce640.svg";